/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Failure codes for failed payments.
 *
 */
export enum PaymentFailureCode {
  PaymentCancelled = 10,
  PaymentTimedOut = 20,
  TransactionFailed = 30,
  IncorrectConfiguration = 40,
  PendingPaymentCancelled = 50,
}

/**
 * Payment statuses.
 *
 */
export enum PaymentStatus {
  Initialized = 0,
  Ready = 10,
  Started = 20,
  Pending = 25,
  PartiallyFunded = 28,
  Charged = 30,
  Failed = 40,
  Refunded = 60,
  FailedAtStart = 80,
  PartiallyRefunded = 90,
}

export enum ExamFormat {
  Pb = 1,
  Cd = 2,
}

export enum OnlinePaymentStatus {
  NotStarted = 0,
  Initialized = 1,
  Successful = 2,
  Failed = 3,
  Abandoned = 4,
}

export enum Gender {
  Male = 1,
  Female = 2,
}

export interface CentreDto {
  code: string;
  name: string;
  city: string;
}

export interface CreateCustomerRequest {
  firstName: string;
  middleName?: string | null;
  lastName: string;
  gender: Gender;
  /** @format date-time */
  birthDate: string;
  email: string;
  phoneNumber: string;
  guardian?: string | null;
  termsConsent: boolean;
  photoConsent: boolean;
  marketingConsent: boolean;
  address: CreateAddressRequest;
  specialRequirements?: SpecialRequirementsRequest | null;
  permissionToLeave?: PermissionToLeaveRequest | null;
  /** @format int32 */
  examDateId: number;
}

export interface CreateAddressRequest {
  street: string;
  city: string;
  postalCode: string;
}

export interface SpecialRequirementsRequest {
  disability: boolean;
  dyslexia: boolean;
  description?: string | null;
}

export interface PermissionToLeaveRequest {
  canLeave: boolean;
  guardianName: string;
  guardianPhone: string;
  personCollectingCandidate?: string | null;
}

export interface GetCustomerConfirmationDto {
  /** @format guid */
  id: string;
  /** @format int32 */
  examDateId: number;
  /** @format date-time */
  paymentDeadline: string;
}

export interface PaymentContextDto {
  /** @format guid */
  customerGuid: string;
  examName: string;
  /** @format date-time */
  examDate: string;
  /** @format decimal */
  amount: number;
  currency: string;
  paymentStatus: OnlinePaymentStatus;
  nppPaymentUrl?: string | null;
}

export interface PaymentInitiationResult {
  /** @format guid */
  paymentId: string;
  paymentPageUrl: string;
}

export interface PaymentStatusResult {
  status: OnlinePaymentStatus;
  nppPaymentId?: string | null;
  /** @format decimal */
  amount: number;
  currency: string;
}

export interface ExamGroupDto {
  /** @format int32 */
  id: number;
  name: string;
}

export interface ExamDateDto {
  /** @format int32 */
  id: number;
  examName: string;
  /** @format int32 */
  examGroupId: number;
  /** @format date-time */
  examDate: string;
  /** @format date-time */
  registrationEndDate: string;
  speakingDates: string;
  centreCode: string;
  city: string;
  examFormat: ExamFormat;
  registrationClosed: boolean;
  /** @format int32 */
  price: number;
  currency: string;
  /** @format int32 */
  slotsLeft?: number | null;
  photoRequired: boolean;
  /** @format int32 */
  paymentDeadlineDays: number;
  /** @format date-time */
  paymentEndDate: string;
}

/**
 * Response required from Client Application to be passed when status is properly processed on Client Application side.
 *
 */
export interface StatusChangeNotificationResponse {
  /**
   * Payment identifier. The same that was passed in request. Information required for success verification.
   *
   * @minLength 36
   * @maxLength 36
   */
  paymentId: string;
  /**
   * Confirmation that payment status was successfully processed. In case of problems, 'false' will force NPP to sent information again after a few minutes delay.
   *
   */
  isSuccessfullyProcessed: boolean;
}

/**
 * Notification sent to Client Application when payment status in NPP changes.
 *
 */
export interface StatusChangeNotificationRequest {
  /**
   * Changed payment identifier.
   *
   * @minLength 36
   * @maxLength 36
   */
  paymentId: string;
  /**
   * Client Application Correlation Id passed on payment start.
   *
   * @minLength 1
   * @maxLength 100
   */
  correlationId: string;
  /**
   * New payment status identifier
   *
   */
  status: PaymentStatus;
  /**
   * If status has some error message attached it will be filled in here.
   *
   * @deprecated
   */
  error?: string | null;
  /**
   * Payment Service Provider which operated the payment.
   *
   * @maxLength 10
   */
  paymentProvider?: string | null;
  /**
   * Human readable payment status.
   *
   * @minLength 1
   */
  statusDescription: string;
  /**
   * Failure code if payment is failed.
   *
   */
  failureCode?: PaymentFailureCode | null;
  /**
   * Amount of overpayment
   *
   * @format decimal
   */
  overpaymentAmount?: number | null;
  /**
   * Amount needed to complete payment
   *
   * @format decimal
   */
  remainingAmount?: number | null;
  /**
   * Payment method used to pay
   *
   */
  paymentMethod?: string | null;
  /**
   * Time of successful payment
   *
   * @format date-time
   */
  paymentTime?: string | null;
}

export interface TermsAndConditionDto {
  contentEn: string;
  fileEn: string;
  contentPl: string;
  filePl: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<
  AxiosRequestConfig,
  "data" | "params" | "url" | "responseType"
> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<
  AxiosRequestConfig,
  "data" | "cancelToken"
> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "http://localhost:58198",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Entrynet API
 * @version 1.0.0
 * @baseUrl http://localhost:58198
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  centres = {
    /**
     * No description
     *
     * @tags Centres
     * @name GetCentres
     * @request GET:/api/centres
     */
    getCentres: (params: RequestParams = {}) =>
      this.request<CentreDto[], any>({
        path: `/api/centres`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  customers = {
    /**
     * No description
     *
     * @tags Customers
     * @name CreateCustomer
     * @request POST:/api/customers
     */
    createCustomer: (data: CreateCustomerRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/customers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name UploadCustomerDocuments
     * @request PUT:/api/customers/{id}/upload-documents
     */
    uploadCustomerDocuments: (
      id: string,
      data: {
        files?: File[] | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/customers/${id}/upload-documents`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetCustomerConfirmation
     * @request GET:/api/customers/{id}/confirmation
     */
    getCustomerConfirmation: (id: string, params: RequestParams = {}) =>
      this.request<GetCustomerConfirmationDto, any>({
        path: `/api/customers/${id}/confirmation`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetPaymentContext
     * @request GET:/api/customers/{customerGuid}/payment
     */
    getPaymentContext: (customerGuid: string, params: RequestParams = {}) =>
      this.request<PaymentContextDto, any>({
        path: `/api/customers/${customerGuid}/payment`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name InitiatePayment
     * @request POST:/api/customers/{customerGuid}/payment
     */
    initiatePayment: (customerGuid: string, params: RequestParams = {}) =>
      this.request<PaymentInitiationResult, any>({
        path: `/api/customers/${customerGuid}/payment`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name CheckPaymentStatus
     * @request POST:/api/customers/{customerGuid}/payment/check-status
     */
    checkPaymentStatus: (customerGuid: string, params: RequestParams = {}) =>
      this.request<PaymentStatusResult, any>({
        path: `/api/customers/${customerGuid}/payment/check-status`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  exams = {
    /**
     * No description
     *
     * @tags Exams
     * @name GetExams
     * @request GET:/api/exams
     */
    getExams: (params: RequestParams = {}) =>
      this.request<ExamGroupDto[], any>({
        path: `/api/exams`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exams
     * @name GetExamDates
     * @request GET:/api/exams/dates
     */
    getExamDates: (params: RequestParams = {}) =>
      this.request<ExamDateDto[], any>({
        path: `/api/exams/dates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exams
     * @name GetExamDate
     * @request GET:/api/exams/dates/{id}
     */
    getExamDate: (id: number, params: RequestParams = {}) =>
      this.request<ExamDateDto, any>({
        path: `/api/exams/dates/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  paymentWebhooks = {
    /**
     * No description
     *
     * @tags PaymentWebhooks
     * @name PaymentStatusCallback
     * @request POST:/api/webhooks/payments/status
     */
    paymentStatusCallback: (
      data: StatusChangeNotificationRequest,
      params: RequestParams = {}
    ) =>
      this.request<StatusChangeNotificationResponse, any>({
        path: `/api/webhooks/payments/status`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  termsAndCondition = {
    /**
     * No description
     *
     * @tags TermsAndCondition
     * @name GetTermsAndCondition
     * @request GET:/api/terms-and-condition
     */
    getTermsAndCondition: (
      query?: {
        /** @format int32 */
        examDateId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<TermsAndConditionDto, any>({
        path: `/api/terms-and-condition`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
